/* CR7 URSU9 Theme — Related Products (Socials)
 *
 * Fills [data-rps-placeholder] cells in .related-products-socials sections
 * with products from Shopify's /recommendations/products.json endpoint.
 *
 * The section Liquid renders placeholder spinners for any grid slots not
 * already occupied by social embeds or pinned rp/ product cells. This script
 * picks those up on DOMContentLoaded, fetches related products for the current
 * product, then renders each placeholder using the same HTML structure and CSS
 * classes as the Liquid-rendered product cells above them.
 *
 * Display options (show_title, show_price, etc.) are read from data attributes
 * on the parent section element so JS-rendered cells match the section settings.
 */

(function () {
  'use strict';

  /* ---------- Helpers -------------------------------------------------- */

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    var n = Number(cents) / 100;
    try {
      return n.toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function csvToSet(csv) {
    var out = new Set();
    if (!csv) return out;
    csv.split(',').forEach(function (h) {
      var s = h.trim().toLowerCase();
      if (s) out.add(s);
    });
    return out;
  }

  /* ---------- Transitions --------------------------------------------- */
  // Reuses the pfs-trans-* keyframes and classes already defined in theme.css.

  var TRANSITION_KINDS = ['fade', 'blur', 'pixellate', 'glitch'];

  function applyTransition(itemEl, kind) {
    if (!itemEl) return;
    if (TRANSITION_KINDS.indexOf(kind) === -1) kind = 'fade';
    TRANSITION_KINDS.forEach(function (k) {
      itemEl.classList.remove('pfs-trans-' + k);
    });
    // Force reflow so the animation restarts cleanly.
    void itemEl.offsetWidth;
    itemEl.classList.add('pfs-trans-' + kind);
  }

  /* ---------- Cell rendering ------------------------------------------ */

  // Replaces a placeholder cell's content with a fully rendered product cell,
  // matching the structure produced by the Liquid rp/ product block above.
  function renderProductCell(cell, product, section, transition) {
    var showTitle   = section.getAttribute('data-show-title')       === 'true';
    var showPrice   = section.getAttribute('data-show-price')       === 'true';
    var showAddCart = section.getAttribute('data-show-add-to-cart') === 'true';
    var showView    = section.getAttribute('data-show-view-button') === 'true';
    var buttonLabel = section.getAttribute('data-button-label')     || '';
    var item        = cell.closest('.three-col-grid__item');

    var url = '/products/' + product.handle;
    var img = product.images && product.images[0];
    var imgSrc = img ? (img.src || img) : '';
    var alt = (img && img.alt) || product.title || '';

    var firstVariant  = product.variants && product.variants[0];
    var available     = firstVariant ? firstVariant.available !== false : true;
    var priceCents    = firstVariant ? Math.round(parseFloat(firstVariant.price) * 100) : null;
    var compareCents  = firstVariant && firstVariant.compare_at_price
      ? Math.round(parseFloat(firstVariant.compare_at_price) * 100)
      : null;

    // Media layer: linked image (same structure as Liquid product block).
    var mediaHtml =
      '<a href="' + escapeHtml(url) + '">' +
        (imgSrc
          ? '<img loading="lazy" alt="' + escapeHtml(alt) + '" src="' + escapeHtml(imgSrc) + '">'
          : '<div class="ig-embed">' + escapeHtml(product.title || '') + '</div>') +
      '</a>';

    var labelHtml = '';
    if (showTitle && product.title) {
      labelHtml = '<div class="three-col-grid__item__label">' + escapeHtml(product.title) + '</div>';
    }

    var footerInner = '';
    if (showPrice && priceCents != null) {
      footerInner +=
        '<div class="price" style="text-align:center">' +
          escapeHtml(formatMoney(priceCents)) +
          (compareCents && compareCents > priceCents
            ? ' <span class="price--compare">' + escapeHtml(formatMoney(compareCents)) + '</span>'
            : '') +
        '</div>';
    }
    if (showAddCart) {
      if (available && firstVariant) {
        footerInner +=
          '<form action="/cart/add" method="post" enctype="multipart/form-data">' +
            '<input type="hidden" name="id" value="' + escapeHtml(String(firstVariant.id)) + '">' +
            '<button type="submit" class="btn">' + escapeHtml(buttonLabel || 'Add to cart') + '</button>' +
          '</form>';
      } else {
        footerInner += '<button type="button" class="btn" disabled>Sold out</button>';
      }
    } else if (showView) {
      footerInner +=
        '<a href="' + escapeHtml(url) + '" class="btn">' +
          escapeHtml(buttonLabel || 'View product') +
        '</a>';
    }
    var footerHtml = footerInner
      ? '<div class="three-col-grid__item__footer">' + footerInner + '</div>'
      : '';

    // Swap the placeholder media div's content and add label/footer siblings.
    cell.classList.remove('pfs-placeholder');
    cell.innerHTML = mediaHtml;

    if (item) {
      item.querySelectorAll('.three-col-grid__item__label, .three-col-grid__item__footer')
        .forEach(function (n) { n.remove(); });
      if (labelHtml || footerHtml) {
        cell.insertAdjacentHTML('afterend', labelHtml + footerHtml);
      }
      applyTransition(item, transition);
    }
  }

  // Hides a placeholder cell that couldn't be filled (no product available).
  function renderEmptyCell(cell) {
    var item = cell.closest('.three-col-grid__item');
    cell.classList.remove('pfs-placeholder');
    cell.innerHTML = '';
    if (item) item.style.display = 'none';
  }

  /* ---------- Section boot -------------------------------------------- */

  function boot(section) {
    var productId  = section.getAttribute('data-product-id');
    var usedSet    = csvToSet(section.getAttribute('data-used-products'));
    var transition = section.getAttribute('data-product-transition') || 'fade';
    var cells      = Array.prototype.slice.call(
      section.querySelectorAll('[data-rps-placeholder]')
    );

    if (!cells.length || !productId) return;

    // Request enough results to cover all placeholders after exclusions.
    // Shopify caps this endpoint at 10 per request.
    var limit = Math.min(cells.length + usedSet.size + 3, 10);

    fetch(
      '/recommendations/products.json' +
        '?product_id=' + encodeURIComponent(productId) +
        '&limit=' + limit +
        '&intent=related',
      { headers: { Accept: 'application/json' } }
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var pool = (json && json.products ? json.products : [])
          .filter(function (p) {
            return !usedSet.has(String(p.handle || '').toLowerCase());
          });

        cells.forEach(function (cell, i) {
          if (pool[i]) {
            renderProductCell(cell, pool[i], section, transition);
          } else {
            renderEmptyCell(cell);
          }
        });
      })
      .catch(function () {
        cells.forEach(function (cell) { renderEmptyCell(cell); });
      });
  }

  /* ---------- Init ----------------------------------------------------- */

  function bootAll() {
    document.querySelectorAll('[data-related-products-socials]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-run when the theme editor reloads this section.
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target && e.target.querySelector
      ? e.target.querySelector('[data-related-products-socials]')
      : null;
    if (sec) boot(sec);
  });
})();
